import { useState } from 'react'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { CreationToolSourceFile } from '../types'
import getProcessedSource from '../utils/get-processed-source'

/**
 * Returns a processed creation file for the source url.
 */
export function useCreationProcessedFile(source?: File | string): CreationToolSourceFile | undefined {
    const [processedSource, setProcessedSource] = useState<CreationToolSourceFile>()

    useAsyncEffect(async () => {
        setProcessedSource(undefined)

        if (source) {
            const processed = await getProcessedSource(source)
            setProcessedSource(processed)
        }
    }, [source])

    return processedSource
}
